import React from 'react'
import { Box, Button, Modal, Text, TextInput } from 'elements'
import ModalContent from '../../app/ModalContent'
import ModalCloseButton from '../../app/ModalCloseButton'

export default function FirstClientUploadSubmitStep({
  onBack,
  onDone,
  submitting,
  reportName,
  setReportName,
  onClose,
}) {
  return (
    <>
      <ModalContent pt="gigantic" px="gigantic">
        <ModalCloseButton onClose={onClose} />
        <Text mb="medium">Step 4: Run report</Text>
        <Text fontSize="small" color="neutral.0" mb="xlarge">
          This first Intro Report includes a comprehensive test of all anomalies.
        </Text>
        <Box>
          <TextInput
            disabled={submitting}
            value={reportName}
            onChange={(event) => setReportName(event.target.value)}
            placeholder="Report name (optional)"
            mb="large"
          />
        </Box>
      </ModalContent>
      <Modal.Footer
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        px="gigantic"
        pb="gigantic"
        width="100%"
      >
        <Button disabled={submitting} onPress={onBack} kind="alt-neutral">
          Back
        </Button>
        <Button disabled={submitting} kind="primary" onPress={onDone}>
          {submitting ? 'Running...' : 'Run Report'}
        </Button>
      </Modal.Footer>
    </>
  )
}
